package com.bikompanion.ui.install

private const val PlayStoreUrl = "https://play.google.com/store/apps/details?id=com.bikompanion"

private val AppleMobileDevice = Regex("iPhone|iPad|iPod")

/**
 * What a browser on this device should offer, or `null` when it has nothing to offer: the app is
 * already installed, or the page is on a desktop.
 *
 * Takes the browser's values rather than reading them so the rule stays testable off the web target.
 *
 * @param maxTouchPoints tells an iPad from a Mac, because iPadOS Safari reports a Mac user agent.
 */
fun browserInstallOffer(
    userAgent: String,
    maxTouchPoints: Int,
    isInstalled: Boolean,
): AppInstallOffer? =
    when {
        isInstalled -> null
        "Android" in userAgent -> AppInstallOffer.OpenStore(PlayStoreUrl)
        AppleMobileDevice.containsMatchIn(userAgent) -> AppInstallOffer.AddToHomeScreen
        "Macintosh" in userAgent && maxTouchPoints > 1 -> AppInstallOffer.AddToHomeScreen
        else -> null
    }
